import { render, staticRenderFns } from "./decision.vue?vue&type=template&id=06b131ee&scoped=true&"
import script from "./decision.vue?vue&type=script&lang=js&"
export * from "./decision.vue?vue&type=script&lang=js&"
import style0 from "./decision.vue?vue&type=style&index=0&id=06b131ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b131ee",
  null
  
)

export default component.exports